/*-- Chart --*/
.bb {
  svg {
    font: var(--body-size-xsmall) sans-serif;
    -webkit-tap-highlight-color: transparent;
  }

  path {
    fill: none;
    stroke: var(--chart-101-pressed-dividers);
  }

  line {
    stroke: transparent;
  }

  text,
  .bb-button {
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
}

.bb-legend-item-tile,
.bb-xgrid-focus,
.bb-ygrid-focus,
.bb-ygrid,
.bb-event-rect,
.bb-bars path {
  shape-rendering: crispEdges;
}

.bb-chart-arc {
  .bb-gauge-value {
    fill: var(--black-layout-700-primary);
  }

  path {
    stroke: transparent;
  }

  rect {
    stroke: var(--black-layout-700-primary);
    stroke-width: 1;
  }

  text {
    fill: var(--body-text-arrows-400);
    font-size: var(--body-size-medium);
  }
}

/*-- Axis --*/
.bb-axis {
  shape-rendering: crispEdges;
}

.bb-axis-x .tick,
.bb-axis-y .tick {
  font-family: var(--font-family);
  color: var(--chart-300-icon-buttons);
  font-size: var(--body-size-xsmall);
}

.bb-axis-x-label {
}

.bb-axis-y-label {
}

.bb-axis-y2 .tick {
}

.bb-axis-y2-label {
}

/*-- Grid --*/
.bb-grid {
  line {
    stroke: var(--chart-101-pressed-dividers);
  }

  text {
    fill: var(--grey-layout-200-disabled);
  }
}

.bb-xgrid,
.bb-ygrid {
  stroke: var(--chart-101-pressed-dividers);
}

/*-- Text on Chart --*/
.bb-text {
  &.bb-empty {
    fill: var(--grey-layout-200-disabled);
    font-size: 2em;
  }
}

/*-- Line --*/
.bb-line {
  stroke-width: 1px;
}

/*-- Point --*/
.bb-circle._expanded_ {
  stroke-width: 1px;
  stroke: white;
}

.bb-selected-circle {
  fill: white;
  stroke-width: 2px;
}

/*-- Bar --*/
.bb-bar {
  stroke-width: 0;

  &._expanded_ {
    fill-opacity: 0.75;
  }
}

/*-- Focus --*/
.bb-target {
  &.bb-focused {
    opacity: 1;
  }

  &.bb-focused {
    path.bb-line,
    path.bb-step {
      stroke-width: 2px;
    }
  }

  &.bb-defocused {
    opacity: 0.3 !important;

    .text-overlapping {
      opacity: 0.05 !important;
    }
  }
}

/*-- Region --*/
.bb-region {
  fill: var(--blue-layout-300-active);
  fill-opacity: 0.1;
}

/*-- Zoom region --*/
.bb-zoom-brush {
  fill-opacity: 0.1;
}

/*-- Brush --*/
.bb-brush .extent {
  fill-opacity: 0.1;
}

/*-- Select - Drag --*/
.bb-dragarea {
}

/*-- Legend --*/
.bb-legend-item {
  font-size: var(--body-size);
  user-select: none;
}

.bb-legend-item-hidden {
  opacity: 0.15;
}

.bb-legend-background {
  opacity: 0.75;
  fill: white;
  stroke: lightgray;
  stroke-width: 1;
}

/*-- Title --*/
.bb-title {
  font: 14px sans-serif;
}

/*-- Tooltip --*/
.bb-tooltip-container {
  z-index: 10;
  user-select: none;
  padding: calc(var(--spacer) * 3);
  border-radius: 8px;
  background-color: var(--white-layout-303-level-2-elevation);
  box-shadow: 0 0 5px var(--chart-050-hover);
}

.bb-tooltip {
  border-collapse: collapse;
  border-spacing: 0;
  border: none;
  empty-cells: show;
  opacity: 0.9;

  tr {
    border: none;
  }

  th {
    font-size: var(--body-size-large);
    padding: 2px 5px;
    text-align: left;
  }

  td {
    font-size: var(--body-size-medium);
    padding: 3px 6px;
    background-color: var(--white-layout-302-level-1-elevation);
    border: none;

    > span,
    > svg {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 6px;
    }
  }

  &.value {
    text-align: right;
  }
}

/*-- Area --*/
.bb-area {
  stroke-width: 0;
  opacity: 0.4;
}

/*-- Arc --*/
.bb-chart-arcs-title {
  dominant-baseline: middle;
  font-size: var(--display-1-size);
}

.bb-chart-arcs-gauge-title {
  dominant-baseline: middle;
  font-size: 2.7em;
}

.bb-chart-arcs {
  .bb-chart-arcs-background {
    fill: var(--white-layout-302-level-1-elevation);
    stroke: var(--chart-101-pressed-dividers);
  }

  .bb-chart-arcs-gauge-unit {
    fill: var(--main-titles-inputs-600);
    font-size: var(--body-size-xxlarge);
  }

  .bb-chart-arcs-gauge-max {
    fill: var(--chart-300-icon-buttons);
  }

  .bb-chart-arcs-gauge-min {
    fill: var(--chart-300-icon-buttons);
  }
}

/*-- Radar --*/
.bb-chart-radars {
  .bb-levels {
    polygon {
      fill: none;
      stroke: var(--chart-101-pressed-dividers);
      stroke-width: 0.5px;
    }

    text {
      fill: var(--chart-101-pressed-dividers);
    }
  }

  .bb-axis {
    line {
      stroke: var(--chart-101-pressed-dividers);
      stroke-width: 0.5px;
    }

    text {
      font-size: 1.15em;
      cursor: default;
    }
  }

  .bb-shapes {
    polygon {
      fill-opacity: 0.2;
      stroke-width: 1px;
    }
  }
}

/*-- Button --*/
.bb-button {
  position: absolute;
  top: 10px;
  right: 10px;

  .bb-zoom-reset {
    font-size: var(--body-size-small);
    border: solid 1px var(--chart-101-pressed-dividers);
    background-color: var(--white-layout-302-level-1-elevation);
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
  }
}
